import { matchStatusUpdate } from '../reducers/playersReducer';
import { setIsRunning, setMinutes, setNewIsRunning, setNewMinutes, setNewSeconds, setSeconds } from '../reducers/settingReducer';
import store from '../store'; // Assuming your Redux store file is named store.js


let intervalId = null;
let startTime = null; // Store the start time
// Old Timer
export const startTimer = (initialMinutes, initialSeconds) => {
  clearInterval(intervalId);
  startTime = Date.now();
  const totalInitialTimeInSeconds = initialMinutes * 60 + initialSeconds;

  intervalId = setInterval(() => {
    const { settingReducer } = store.getState();
    let { minutes, seconds } = settingReducer;

    const currentTime = Date.now();
    const elapsedTimeInSeconds = Math.floor((currentTime - startTime) / 1000);

    let remainingTimeInSeconds = totalInitialTimeInSeconds - elapsedTimeInSeconds;

    // Ensure the timer stops when 1 second remains
    if (remainingTimeInSeconds <= 0) {
      clearInterval(intervalId);
      remainingTimeInSeconds = 0;
      store.dispatch(setMinutes(0));
      store.dispatch(setSeconds(0));
      store.dispatch(setIsRunning(false));
      store.dispatch(matchStatusUpdate('pause'));
      return;
    }

    // Calculate new minutes and seconds from remaining time
    minutes = Math.floor(remainingTimeInSeconds / 60);
    seconds = remainingTimeInSeconds % 60;

    // Dispatch the updated minutes and seconds to the store
    store.dispatch(setMinutes(minutes));
    store.dispatch(setSeconds(seconds));
  }, 1000);

  store.dispatch(setIsRunning(true));
};

export const stopTimer = () => {
  clearInterval(intervalId);
  store.dispatch(setIsRunning(false));
};

// New Timer Code
let newIntervalId = null;

export const startNewTimer = () => {
  clearInterval(newIntervalId);
  const state = store.getState();
  const { settingReducer } = store.getState();
  let { newMinutes, newSeconds } = settingReducer;

  newIntervalId = setInterval(() => {
    if (newSeconds === 59) {
      newMinutes++;
      newSeconds = 0;
    } else {
      newSeconds++;
    }

    store.dispatch(setNewMinutes(newMinutes));
    store.dispatch(setNewSeconds(newSeconds));
  }, 1000);

  store.dispatch(setNewIsRunning(true));
};

export const stopNewTimer = () => {
  clearInterval(newIntervalId);
  store.dispatch(setNewIsRunning(false));
};

export const resetNewTimer = () => {
  clearInterval(newIntervalId);
  store.dispatch(setNewMinutes(0));
  store.dispatch(setNewSeconds(0));
  store.dispatch(setNewIsRunning(false));
};
